<script>
/**
 * @Author: shenyi
 * @Date:   2024-01-17 18:30:54
 * @Last Modified by:   shenyi
 * @Last Modified time: 2024-01-22 15:06:40
 */
</script>
<template>
  <div class="forgotPassword">
    <div class="forgotPassword_school_icon">
      <img src="../assets/imgs/loginSchoolIcon.png" alt="" width="100%" />
    </div>
    <div class="forgotPassword_systmeName">北师大实验国际部简历系统</div>
    <div class="forgotPassword_form">
      <div class="forgotPassword_form_title">忘记密码</div>

      <el-form
        v-if="!newPassword"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="110px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-form-item label="手机号：" prop="mobilePhone">
          <el-input v-model="ruleForm.mobilePhone"></el-input>
        </el-form-item>

        <el-form-item
          label="图形验证码："
          prop="validateCode"
          class="validateCode"
        >
          <el-input v-model="ruleForm.validateCode"></el-input>
          <div class="codeImg" @click="getImgCode">
            <img :src="imageVerifyUrl" alt="" width="100%" height="100%" />
          </div>
        </el-form-item>
        <el-form-item
          label="短信验证码："
          prop="code"
          class="messageValidateCode"
        >
          <el-input v-model="ruleForm.code"></el-input>
          <el-button
            type="primary"
            @click="getMobileCode"
            class="purple"
            :class="identityClass"
            >{{ identityText }}</el-button
          >
        </el-form-item>
        <el-form-item class="operate">
          <el-button @click="backLogin" class="default">返回登录</el-button>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            class="purple"
            :disabled="loginDisable"
            >重置密码</el-button
          >
        </el-form-item>
      </el-form>

      <div class="newPasswordResetDiv" v-else>
        <div class="passwordResetImg"></div>

        <div class="passwordResetWord">密码已重置</div>
        <div class="newPassworgOperate">
          <div class="newPassworg">{{ newPassword }}</div>
          <div class="copyButton" @click="copyPassword">复制</div>
        </div>
        <div class="loginBtn" @click="goLogin">去登录</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, FormItem, Input, Button, Message } from "element-ui";
Vue.use(Form).use(FormItem).use(Input).use(Button);

export default {
  name: "forgotPassword",
  data() {
    return {
      ruleForm: {
        mobilePhone: "",
        validateCode: "",
        code: "",
      },
      rules: {
        mobilePhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],

        validateCode: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
      imageVerifyToken: "",
      imageVerifyUrl: "",
      loginDisable: false,

      identityText: "获取验证码",
      // 验证码60s倒计时
      countdown: 60,
      // 获取验证码按钮的class
      identityClass: "identityInitial",

      newPassword: null,
    };
  },
  methods: {
    goLogin(){

      this.$router.push(
        {
          path: '/login'
        }
      )

    },
    copyPassword() {
      if (!navigator.clipboard) {
        // 如果不支持，则使用传统的 document.execCommand("copy") 方式
        const textArea = document.createElement("textarea");
        textArea.value = copyUrl;
        textArea.style.position = "fixed";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        Message({
          type: "success",
          message: "操作成功,已复制链接到剪切板！",
          duration: 800,
          onClose() {},
        });

        return;
      }

      navigator.clipboard.writeText(this.newPassword).then(
        function () {
          Message({
            type: "success",
            message: "操作成功,已复制链接到剪切板！",
            duration: 800,
            onClose() {},
          });
        },
        function () {
          Message({
            type: "success",
            message: "复制失败！",
            duration: 800,
            onClose() {},
          });
        }
      );
    },
    submitForm(form) {
      const that = this;
      this.$refs[form].validate((valid) => {
        if (valid) {
          that.loginDisable = true;
          that.ruleForm.validateToken = that.imageVerifyToken;

          that
            .$axios({
              method: "post",
              url: "/galaxy/baoming/api/v1/baoming/mgr/resetMyApplicantPassword",

              data: {
                ...that.ruleForm,
                tenantId: process.env.VUE_APP_TENANTID,
                batchId: process.env.VUE_APP_BATCHID,
              },

              headers: {
                params: true,
              },
            })
            .then((result) => {
              const res = result.data;
              if (
                result.code === "1000000" &&
                res &&
                JSON.stringify(res) !== "{}"
              ) {
                that.newPassword = res;

                Message({
                  type: "success",
                  message: "密码重置成功！",
                  duration: 800,
                  onClose() {},
                });
              }
            });
        }
      });
    },

    backLogin() {
      this.$router.push({
        path: "/login",
      });
    },
    // 获取图形验证码
    getImgCode() {
      this.$axios
        .get(`/galaxy/baoming/api/v1/huaxia/applicant/generateValidateCode`)
        .then((result) => {
          const res = result.data;
          if (
            result.code === "1000000" &&
            res &&
            JSON.stringify(res) !== "{}"
          ) {
            this.imageVerifyToken = res.imageVerifyToken;
            this.imageVerifyUrl = res.url;
          } else {
            this.imageVerifyToken = "";
            this.imageVerifyUrl = "";
          }
        });
    },
    // 获取短信验证码
    getMobileCode() {
      const that = this;
      if (that.ruleForm.validateCode) {
        if (that.countdown === 60) {
          that
            .$axios({
              method: "get",
              url: "/galaxy/baoming/api/v1/baoming/mgr/sendPhoneMsg",
              params: {
                codetoken: that.imageVerifyToken,
                code: that.ruleForm.validateCode,
                phone: that.ruleForm.mobilePhone,
                tenantId: process.env.VUE_APP_TENANTID,
              },

              headers: {
                params: true,
              },
            })
            .then((result) => {
              const res = result.data;
              if (result.code === "1000000" && res) {
                Message({
                  type: "success",
                  message: "验证码已发送，请注意查收",
                  duration: 800,
                });
                that.identityClass = "identityFinal";
                const interval = setInterval(() => {
                  if (that.countdown === 0) {
                    that.identityText = "重新获取";
                    that.countdown = 60;
                    that.identityClass = "identityInitial";
                    clearInterval(interval);
                  } else {
                    that.countdown--;
                    that.identityText = that.countdown + "s";
                  }
                }, 1000);
              } else {
                that.getImgCode();
              }
            });
        } else {
          Message({
            type: "warning",
            message: "不能重复点击！",
            duration: 800,
          });
        }
      } else {
        Message({
          type: "warning",
          message: "请先填写图形验证码",
          duration: 800,
        });
      }
    },
  },
  created() {
    this.getImgCode();
  },
};
</script>

<style lang="scss" scoped>
.forgotPassword {
  width: 100vw;
  height: 100vh;
  background: #edf3f7;
  padding-top: 4%;
  .forgotPassword_school_icon {
    width: 30%;
    // width: 629px;
    // height: 123px;
    margin: 0 auto 20px;
    // background-image: url('../assets/imgs/loginSchoolIcon.png');
  }
  .forgotPassword_systmeName {
    text-align: center;
    color: #474747;
    font-size: 32px;
  }
  .forgotPassword_form {
    width: 486px;
    margin: 50px auto 0;
    background-color: #fff;
    padding: 20px 36px;
    border-radius: 10px;
    .forgotPassword_form_title {
      font-size: 24px;
      color: #353535;
      margin-bottom: 24px;
    }
  }
}
</style>
<style lang="scss">
.forgotPassword {
  .newPasswordResetDiv {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .passwordResetImg {
      margin: auto;
      width: 160px;
      height: 121px;
      background: url("../assets/imgs/newPassword.svg") no-repeat center center;
      background-size: contain;
    }
    .passwordResetWord {
      font-family: Microsoft YaHei UI;
      font-size: 12px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0px;
      text-align: left;
      color: rgba(0, 0, 0, 0.85);
      margin: auto;
      display: flex;
      align-content: center;
      justify-content: center;
      padding-top: 16px;
    }
    .newPassworgOperate {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 16px;
      .newPassworg {
        font-family: Microsoft YaHei UI;
        font-size: 22px;
        font-weight: 400;
        line-height: 33px;
        letter-spacing: 0px;
        text-align: left;
        margin-right: 8px;
      }
      .copyButton {
        cursor: pointer;
        width: 44px;
        height: 26px;
        border: 1px solid rgba(24, 144, 255, 1);
        font-family: Microsoft YaHei UI;
        font-size: 12px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(24, 144, 255, 1);
        display: flex;
        align-content: center;
        justify-content: center;
      }
    }
    .loginBtn {
      cursor: pointer;
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 210px;
      height: 44px;
      background: rgba(24, 144, 255, 1);
      font-family: Microsoft YaHei UI;
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0px;
      text-align: left;
      color: rgba(255, 255, 255, 1);
      border-radius: 5px;
    }
  }
  .messageValidateCode {
    .el-form-item__content {
    }
    .el-button {
      float: right;
      width: 102px;
      height: 32px;
      text-align: center;
      padding: 0;
    }
    .el-input {
      float: left;
      width: 196px;
      .el-input__inner {
        width: 196px;
      }
    }
  }
  .el-form-item__label {
    color: rgba(0, 0, 0, 0.85);
  }
  .el-input {
    height: 32px;
    line-height: 32px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
  .validateCode {
    .codeImg {
      float: right;
      width: 80px;
      height: 32px;
      background-color: rgba(226, 134, 148, 1);
      margin-top: 0px;
      cursor: pointer;
    }
    .el-input {
      float: left;
      width: 220px;
      .el-input__inner {
        width: 220px;
      }
    }
  }
  .operate {
    .el-form-item__content {
      margin-left: 0 !important;
    }
    .el-button {
      width: 198px;
    }
    .el-button + .el-button {
      margin-left: 16px;
    }
  }
  .purple {
    background-color: #1890ff !important;
    border-color: #1890ff !important;
    &:hover {
      background-color: #1890ff;
      border-color: #1890ff;
      color: #fff;
    }
  }
  .default:hover {
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
  }
}
</style>
